import axios from "../config/axios";
import live_display_socket from "../config/live_display_socket";
import useGlobalStore from "../store/global.store";

export const useRemote = () => {
  const showVipUpgrade = useGlobalStore((state) => state.showVipUpgrade);
  const setShowVipUpgrade = useGlobalStore((state) => state.setShowVipUpgrade);

  const updateView = (view, onSuccess = null) => {
    const device = JSON.parse(localStorage.getItem("device_data"));

    if (showVipUpgrade) {
      setShowVipUpgrade(false);
    }

    axios
      .patch(
        `/users/device/${device._id}`,
        { screen_view: view },
        { withCredentials: true }
      )
      .then(() => {
        live_display_socket.emit("remote_refresh", {
          device_id: device?._id,
        });
        if (onSuccess) {
          new Promise((resolve) => setTimeout(resolve, 1500)).then(() => {
            onSuccess();
          });
        }
      })
      .catch((error) => {});
  };

  return { updateView };
};
